import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const HomePage = () => import("../views/HomePage");
const EsgPage = () => import("../views/EsgPage");
const CareerPage = () => import("../views/CareerPage");
const NewPage = () => import("../views/NewPage");

const router = new VueRouter({
  mode: "history",
  base: __dirname,
  routes: [
    {
      path: "/",
      component: HomePage,
    },
    {
      path: "/esg",
      component: EsgPage,
    },
    {
      path: "/career",
      component: CareerPage,
    },
    {
      path: "/news/:id",
      component: NewPage,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
